<template>
    <!--  <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">-->
    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <Header/>
        <div
            :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'"
            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
            <section class="style__SpotlightInnerWrap-sc-1qapdh8-0 kKgHVc">
                <div class="spotlight"
                     :style="$i18n.locale == 'العربية' ?'float:right;width:100%;':'float:left;width:100%;'">
                    <div class="style__SpotlightItemStyled-vo40go-0 cDscbW">
                        <figure>
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                <div aria-hidden="true" style="width:100%;padding-bottom:49.5%"></div>

                                <picture v-if="this.pagedata"><img
                                    :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner"
                                    alt=""
                                    style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>

                                </picture>


                                <!--            <video style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"-->
                                <!--                   v-if="this.pagedata && this.pagedata.id==51"  width="100%"-->
                                <!--                   height="100%" autoplay loop>-->
                                <!--                <source :src="this.serverurl+'/public/pagebanners/scalping.webm'" type="video/webm" style="position:absolute;top:0;left:0;opacity:1;min-width:100%;min-height:100%;object-fit:cover;object-position:center" />-->
                                <!--                Your browser does not support the video tag.-->
                                <!--            </video>-->

                            </div>
                        </figure>
                        <div class="spotlight__info"
                             :style="$i18n.locale == 'العربية' ?'float:right;width:100%;padding-left:8%;padding-right:8%':'float:left;margin-left:3%;width:100%;padding-left:8%;padding-right:8%'">
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY"
                                     :style="$i18n.locale == 'العربية' ?'float:right;margin-right:3%;width: 50%;':'float:left;margin-left:3%;width: 50%;'">
                                    <h2 v-if="pagedata"
                                        :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.page_entitle : $i18n.locale == 'العربية' ? pagedata.page_artitle : $i18n.locale == '中文' ? pagedata.page_chtitle : $i18n.locale == 'Русский' ? pagedata.page_rutitle : pagedata.page_frtitle
                                        }}</h2>
                                    <br/>

                                    <h3 v-if="pagedata"
                                        :style="$i18n.locale == 'العربية' ?'text-align: right;font-size: 23px!important;color:#ffffff;font-family: Cairo,sans-serif !important;margin-right:2%;':'font-size: 23px!important;color:#ffffff;font-family: Comfortaa!important;margin-left:2%'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.en_subtitle : $i18n.locale == 'العربية' ? pagedata.ar_subtitle : $i18n.locale == '中文' ? pagedata.ch_subtitle : $i18n.locale == 'Русский' ? pagedata.ru_subtitle : pagedata.fr_subtitle
                                        }}</h3>
                                </div>
                            </div>
                            <div class="btn_wrap"
                                 :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:3%!important':'width:100%;float:left;margin-left:3%!important'">

                                <div class="react-reveal"
                                     :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"
                                         style="width: 100%!important;text-align: center!important;"><a style=""
                                                                                                        href="https://marketequityinc.com/custom/demoaccountlinks.php"
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"><span>
                                        {{
                                            $i18n.locale == 'en' ? 'Open Demo Account' : $i18n.locale == 'العربية' ? 'فتح حساب تجريبي' : $i18n.locale == '中文' ? '开设模拟账户' : $i18n.locale == 'Русский' ? 'Открыть демо-аккаунт' : 'Ouvrir un compte Dé'

                                        }}

                                        </span></a></div>
                                </div>
                                <div class="react-reveal"
                                     :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"
                                         style="width: 100%!important;text-align: center!important;"><a style=""
                                                                                                        href="https://marketequityinc.com/custom/liveaccountlinks.php"
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"><span>
                                            {{
                                            $i18n.locale == 'en' ? 'Open Live Account' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي' : $i18n.locale == '中文' ? '开设真实账户' : $i18n.locale == 'Русский' ? 'Открыть реальный аккаунт' : 'Ouvrir un compte Réel'
                                        }}
                                        </span></a></div>
                                </div>
                                <div v-if="pagedata.layout==4" class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 360ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"><a class="no-border"
                                                                                      href="https://www.linkedin.com/company/market-equity-inc/?originalSubdomain=in"
                                                                                      target="_blank"
                                                                                      rel="noopener noreferrer">
                                        <div class=" gatsby-image-wrapper"
                                             style="position: relative; overflow: hidden; display: inline-block; width: 100px; height: 30px;">
                                            <picture><img loading="lazy" width="100" height="30"
                                                          src="https://dev.marketequityinc.com/public/public/follow-linkedin.jpg"
                                                          alt="Follow us on Linked In"
                                                          style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </div>
                                    </a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>

                <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo">

                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                        <div class="react-reveal"
                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">


                            <div class="form-content"
                                 style="width:100%!important;height:auto;margin-left:2%;margin-right:2%;margin-top:3%">
                                <div class="row">
                                    <!-- First Form Division -->

                                    <div class="col-md-12 col-sm-12">
                                        <h5 style="margin-bottom:2%;  line-height: 30px;">Empower your trading decisions with our complete
                                            array of financial calculators</h5>
                                        <ul class="nav nav-tabs" style="margin-bottom:2%">
                                            <li class="nav-item">
                                                <a
                                                    :class="{ active: selectedTab === 'pip' }"
                                                    class="nav-link"
                                                    href="#"
                                                    @click.prevent="selectedTab = 'pip'"
                                                >Pip Value Calculator</a
                                                >
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    :class="{ active: selectedTab === 'margin' }"
                                                    class="nav-link"
                                                    href="#"
                                                    @click.prevent="selectedTab = 'margin'"
                                                >Required Margin</a
                                                >
                                            </li>

                                            <li class="nav-item">
                                                <a
                                                    :class="{ active: selectedTab === 'lotsize' }"
                                                    class="nav-link"
                                                    href="#"
                                                    @click.prevent="selectedTab = 'lotsize'"
                                                >Lot Size</a
                                                >
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    :class="{ active: selectedTab === 'retracement' }"
                                                    class="nav-link"
                                                    href="#"
                                                    @click.prevent="selectedTab = 'retracement'"
                                                > Fibonacci Retracement</a
                                                >
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    :class="{ active: selectedTab === 'pivotpoints' }"
                                                    class="nav-link"
                                                    href="#"
                                                    @click.prevent="selectedTab = 'pivotpoints'"
                                                >Pivot Points</a
                                                >
                                            </li>
                                        </ul>

                                        <!-- Pip Value Calculator Form -->
                                        <div v-if="selectedTab === 'pip'">
                                            <div class="row">
                                                <div
                                                    class="col-md-3 col-sm-12 d-flex justify-content-center align-items-center"
                                                    style="margin-top:2%">
                                                    Market Equity is fully committed to safeguard its clients with AML
                                                    compliance and in respect to all relevant legal requirements. We
                                                    have become one of the efficient companies on Meta’s trader
                                                </div>
                                                <div class="col-md-6 col-sm-12" style="margin-top:2%">
                                                    <div style="width: 100%;
    padding: 20px;
    border-radius: 6px ;
        border: 0px solid #808080; /* Grey border color */

    background: #fff;
    box-shadow: 0 0 6px 0 #808080;">
                                                        <form id="tradingForm" style="margin-top: 3%; background-color: #ffffff;box-shadow: 0 0 0px 0 #ffffff;">
                                                            <div class="form-group">
                                                                <label for="instrument" style="color: #1c879f;text-align: left!important;display: block;">Instrument</label>
                                                                <select
                                                                    id="instrument"
                                                                    v-model="selectedSymbol"
                                                                    class="form-control"
                                                                    :class="{'is-invalid': isFieldInvalid('selectedSymbol')}"
                                                                    @change="onSymbolChange"
                                                                    style="height:8%"
                                                                >
                                                                    <option v-for="item in filteredSymbols" :key="item" :value="item">
                                                                        {{ item }}
                                                                    </option>
                                                                </select>
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="exchangeRate" style="color: #1c879f;text-align: left!important;display: block;">Exchange Rate</label>
                                                                <input
                                                                    id="exchangeRate"
                                                                    v-model="exchangeRate"
                                                                    class="form-control"
                                                                    :class="{'is-invalid': isFieldInvalid('exchangeRate')}"
                                                                    disabled
                                                                    placeholder="Enter Exchange Rate"
                                                                    type="text"
                                                                />
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="pipSize" style="color: #1c879f;text-align: left!important;display: block;">Pip Size</label>
                                                                <input
                                                                    id="pipSize"
                                                                    v-model="pipSize"
                                                                    class="form-control"
                                                                    :class="{'is-invalid': isFieldInvalid('pipSize')}"
                                                                    disabled
                                                                    placeholder="Enter Pip Size"
                                                                    type="text"
                                                                />
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="positionSize" style="color: #1c879f;text-align: left!important;display: block;">Position Size</label>
                                                                <input
                                                                    id="positionSize"
                                                                    v-model.number="positionSize"
                                                                    class="form-control"
                                                                    :class="{'is-invalid': isFieldInvalid('positionSize')}"
                                                                    placeholder="Enter Position Size"
                                                                    type="number"
                                                                />
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="accountCurrency" style="color: #1c879f;text-align: left!important;display: block;">Account Currency</label>
                                                                <select
                                                                    id="accountCurrency"
                                                                    v-model="currency"
                                                                    class="form-control"
                                                                    style="height:8%"
                                                                    :class="{'is-invalid': isFieldInvalid('currency')}"
                                                                >
                                                                    <option value="USD">USD - United States Dollar</option>
<!--                                                                    <option value="EUR">EUR - Euro</option>-->
<!--                                                                    <option value="GBP">GBP - British Pound</option>-->
<!--                                                                    <option value="JPY">JPY - Japanese Yen</option>-->
                                                                    <!-- Add more currencies as needed -->
                                                                </select>
                                                            </div>

                                                            <div v-if="referencepair" class="form-group">
                                                                <label for="referencepairlbl" style="color: #1c879f;text-align: left!important;display: block;">{{ referencepair }}</label>
                                                                <input
                                                                    id="refexchangeRate"
                                                                    v-model.number="refexchangeRate"
                                                                    class="form-control"
                                                                    :class="{'is-invalid': isFieldInvalid('refexchangeRate')}"
                                                                    placeholder="Enter Exchange Rate"
                                                                    type="text"
                                                                />
                                                            </div>

                                                            <div>
                                                                <button class="btn btn-primary w-100" style="border-radius: 0px!important;" type="button" @click="pipcalculate">
                                                                    Calculate
                                                                </button>
                                                            </div>
                                                        </form>

                                                        <div class="output-container">
                                                            <div class="output-box" style="margin-top: 5%;">
                                                                <p v-if="loading">Calculating...</p>

                                                                <h3 style="color:#1F8AA2!important;font-size:18px;font-weight:bold">
                                                                    Pip Value: {{ pipvalue }}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Margin Calculator Form -->
                                        <!-- Your margin calculator form goes here -->
                                        <div v-if="selectedTab === 'margin'">


                                            <div class="row">
                                                <div
                                                    class="col-md-3 col-sm-12 d-flex justify-content-center align-items-center">
                                                    Market Equity is fully committed to safeguard its clients with AML
                                                    compliance and in respect to all relevant legal requirements. We
                                                    have become one of the efficient companies on Meta’s trader
                                                </div>
                                                <div class="col-md-6 col-sm-12" style="margin-top:2%">
                                                    <div style="width: 100%;
    padding: 20px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 0 20px 0 #808080;">
                                                        <form id="tradingForm3"
                                                              style="margin-top: 3%; background-color: #ffffff;box-shadow: 0 0 0px 0 #ffffff;">
                                                            <!--                                            <form id="tradingForm3" style="margin-top: 3%; background-color: #ffffff;">-->
                                                            <div class="form-group">
                                                                <label for="instrument"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Instrument</label>
                                                                <select
                                                                    id="instrument3"
                                                                    v-model="symbolselected"
                                                                    class="form-control"
                                                                    style="height: 2%"
                                                                    @change="onSymbolChangemargin"
                                                                >
                                                                    <option v-for="item in filteredSymbols" :key="item" :value="item">
                                                                        {{ item }}
                                                                    </option>
                                                                    <!-- Add more options as needed -->
                                                                </select>
                                                            </div>
                                                            <div class="form-group">
                                                                <label for="accountCurrency"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Type</label>
                                                                <select
                                                                    id="tradetype"
                                                                    v-model="tradetype"
                                                                    class="form-control"
                                                                    style="height: 2%"
                                                                >
                                                                    <option value="0">Buy
                                                                    </option> <option value="1">Sell</option>

                                                                    <!-- Add more currencies as needed -->
                                                                </select>
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="pipSize" style="color: #1c879f;text-align: left!important;display: block;">Leverage</label>
                                                                <select  id="pipSize3" v-model="leverage" class="form-control" :disabled="disabled"  style="height:8%">
                                                                    <option value="10:1">1:10</option>
                                                                    <option value="25:1">1:25</option>
                                                                    <option value="50:1">1:50</option>
                                                                    <option selected="selected" value="100:1">1:100</option>
                                                                    <option value="200:1">1:200</option>
                                                                    <option value="400:1">1:400</option>
                                                                    <option value="500:1">1:500</option>
                                                                </select>
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="positionSize"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Position
                                                                    Size</label>
                                                                <input
                                                                    id="positionSize3"
                                                                    v-model.number="positionSize"
                                                                    :step="step"
                                                                    class="form-control"
                                                                    placeholder="Enter Position Size"
                                                                    type="number"
                                                                />
                                                            </div>
                                                            <div class="form-group">
                                                                <label for="accountCurrency"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Margin
                                                                    Currency</label>
                                                                <input disabled type="text"  v-model="margincurrency" />
                                                                <select hidden
                                                                    id="accountCurrency3"
                                                                    v-model="currency"
                                                                    class="form-control"
                                                                    style="height: 2%"
                                                                >
                                                                    <option value="USD">USD - United States Dollar
                                                                    </option>
<!--                                                                    <option value="EUR">EUR - Euro</option>-->
<!--                                                                    <option value="GBP">GBP - British Pound</option>-->
<!--                                                                    <option value="JPY">JPY - Japanese Yen</option>-->
<!--                                                                    <option value="AUD">AUD - Australian Dollar</option>-->
<!--                                                                    <option value="CAD">CAD - Canadian Dollar</option>-->
<!--                                                                    <option value="CHF">CHF - Swiss Franc</option>-->
<!--                                                                    <option value="CNY">CNY - Chinese Yuan</option>-->
<!--                                                                    <option value="SEK">SEK - Swedish Krona</option>-->
<!--                                                                    <option value="NZD">NZD - New Zealand Dollar-->
<!--                                                                    </option>-->
                                                                    <!-- Add more currencies as needed -->
                                                                </select>
                                                            </div>

                                                            <div class="form-group" v-if="refexchangeRate">
                                                                <label for="label"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">
                                                                        Price
                                                                    </label>
                                                                <input
                                                                    id="exchangeRate3"
                                                                    v-model="refexchangeRate"
                                                                    class="form-control"

                                                                    placeholder="Enter Exchange Rate"
                                                                    type="text"
                                                                />
                                                            </div>

                                                        </form>
                                                        <div class="text-center">
                                                            <button class="btn btn-primary w-100"
                                                                    style="border-radius: 0px!important;" type="button"
                                                                    @click="margincalculate">
                                                                Calculate
                                                            </button>
                                                        </div>

                                                        <div class="output-container">
                                                            <div class="output-box" style="margin-top: 5%;">
                                                                <h3 style="color:#1F8AA2!important;font-size:18px;font-weight:bold">                                                        <p v-if="loadingmargin">Calculating...</p>

                                                                    Required Margin : ${{
                                                                        formatNumber(requiredmargin)
                                                                    }}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Margin Rate Calculator Form -->
                                        <div v-if="selectedTab === 'lotsize'">
                                            <div class="row">
                                                <div
                                                    class="col-md-3 col-sm-12 d-flex justify-content-center align-items-center">
                                                    Market Equity is fully committed to safeguard its clients with AML
                                                    compliance and in respect to all relevant legal requirements. We
                                                    have become one of the efficient companies on Meta’s trader
                                                </div>
                                                <div class="col-md-6 col-sm-12" style="margin-top:2%">
                                                    <div style="width: 100%;
    padding: 20px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 0 20px 0 #808080;">

                                                        <form id="lotsizeForm"
                                                              style="margin-top: 3%; background-color: #ffffff;box-shadow: 0 0 0px 0 #ffffff;">
                                                            <div class="form-group">
                                                                <label for="instrument"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Instrument</label>
                                                                <select
                                                                    id="instrumentlotsize"
                                                                    v-model="selectedSymbol"
                                                                    class="form-control"
                                                                    style="height: 2%"
                                                                    @change="onSymbolChange"
                                                                >
                                                                    <option v-for="item in filteredSymbols" :key="item" :value="item">
                                                                        {{ item }}
                                                                    </option>
                                                                </select>
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="exchangeRate"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Exchange
                                                                    Rate</label>
                                                                <input
                                                                    id="exchangeRate2"
                                                                    v-model="exchangeRate"
                                                                    class="form-control"
                                                                    disabled
                                                                    placeholder="Enter Exchange Rate"
                                                                    type="text"
                                                                />
                                                            </div>
                                                            <div class="form-group">
                                                                <label for="pipSize"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Pip
                                                                    Size</label>
                                                                <input
                                                                    id="pipSize2"
                                                                    v-model="pipSize"
                                                                    class="form-control"
                                                                    disabled
                                                                    placeholder="Enter Pip Size"
                                                                    type="text"
                                                                />
                                                            </div>
<!--                                                            <div class="form-group">-->
<!--                                                                <label for="positionSize"-->
<!--                                                                       style="color: #1c879f;text-align: left!important;display: block;">Position-->
<!--                                                                    Size</label>-->
<!--                                                                <input-->
<!--                                                                    id="positionSize2"-->
<!--                                                                    v-model.number="positionSize"-->
<!--                                                                    :step="step"-->
<!--                                                                    class="form-control"-->
<!--                                                                    placeholder="Enter Position Size"-->
<!--                                                                    type="number"-->
<!--                                                                />-->
<!--                                                            </div>-->

                                                            <!--                                                <div class="form-group">-->
                                                            <!--                                                    <label for="pipSize" style="color: #ffffff">Pip Size</label>-->
                                                            <!--                                                    <input-->
                                                            <!--                                                        id="pipSizelotsize"-->
                                                            <!--                                                        v-model="lotpipSize"-->
                                                            <!--                                                        class="form-control"-->
                                                            <!--                                                        disabled-->
                                                            <!--                                                        placeholder="Enter Pip Size"-->
                                                            <!--                                                        type="text"-->
                                                            <!--                                                    />-->
                                                            <!--                                                </div>-->

                                                            <div class="form-group">
                                                                <label for="positionSize"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Account
                                                                    Size</label>
                                                                <input
                                                                    id="positionSizelotsize"
                                                                    v-model="positionSize"
                                                                    class="form-control"
                                                                    placeholder="Enter Account Size"
                                                                    type="number"
                                                                />
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="risk"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Risk</label>
                                                                <div class="d-flex">
                                                                    <input
                                                                        id="risk"
                                                                        v-model.number="riskvalue"
                                                                        :step="step"
                                                                        class="form-control"
                                                                        placeholder="Enter Position Size"
                                                                        style="flex: 1; margin-right: 0px;height:8%"
                                                                        type="text"
                                                                    />
                                                                    <select
                                                                        id="risktype"
                                                                        v-model="risktype"
                                                                        class="form-control"
                                                                        style="flex: 1;margin-top:1%;height:8%;color: #1c879f;text-align: left!important;display: block;"
                                                                    >
                                                                        <option value="%">%</option>
                                                                        <option value="usd">USD</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="stoplossvalue"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Stop
                                                                    Loss</label>
                                                                <div class="d-flex">
                                                                    <input
                                                                        id="stoplossvalue"
                                                                        v-model.number="stoplossvalue"
                                                                        class="form-control"
                                                                        placeholder="Enter Stop Loss"
                                                                        style="flex: 1; margin-right: 0px;height:8%"
                                                                        type="number"
                                                                    />
                                                                    <select
                                                                        id="stoplosstype"
                                                                        v-model="stoplosstype"
                                                                        class="form-control"
                                                                        style="flex: 1;margin-top:0%;height:8%;color: #1c879f;text-align: left!important;display: block;"
                                                                    >
                                                                        <option value="PIPS">PIPS</option>
                                                                        <option value="Price">Price</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div class="form-group">
                                                                <label for="accountCurrency"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Deposit
                                                                    Currency</label>
                                                                <select
                                                                    id="accountCurrencylotsize"
                                                                    v-model="currency"
                                                                    class="form-control"
                                                                    style="height: 2%"
                                                                >
                                                                    <option value="USD">USD - United States Dollar
                                                                    </option>
<!--                                                                    <option value="EUR">EUR - Euro</option>-->
<!--                                                                    <option value="GBP">GBP - British Pound</option>-->
<!--                                                                    <option value="JPY">JPY - Japanese Yen</option>-->
<!--                                                                    <option value="AUD">AUD - Australian Dollar</option>-->
<!--                                                                    <option value="CAD">CAD - Canadian Dollar</option>-->
<!--                                                                    <option value="CHF">CHF - Swiss Franc</option>-->
<!--                                                                    <option value="CNY">CNY - Chinese Yuan</option>-->
<!--                                                                    <option value="SEK">SEK - Swedish Krona</option>-->
<!--                                                                    <option value="NZD">NZD - New Zealand Dollar-->
<!--                                                                    </option>-->
                                                                </select>
                                                            </div>

                                                            <div v-if="referencepair" class="form-group">
                                                                <label for="referencepairlbl"
                                                                       style="color: #ffffff">{{
                                                                        referencepair
                                                                    }}</label>
                                                                <input
                                                                    id="refexchangeRateid"
                                                                    v-model.number="refexchangeRate"
                                                                    class="form-control"
                                                                    placeholder="Enter Position Size"
                                                                    type="text"
                                                                />
                                                            </div>

                                                            <div class="text-center">
                                                                <button class="btn btn-primary w-100"
                                                                        style="border-radius: 0px!important;"
                                                                        type="button" @click="lotcalculate">
                                                                    Calculate
                                                                </button>
                                                            </div>
                                                        </form>

                                                        <div class="output-container">
                                                            <div class="output-box"
                                                                 style="margin-top: 5%;max-width:100%!important;">
                                                                <p v-if="loading">Calculating...</p>
                                                                <h3 style="color:#1F8AA2!important;font-size:18px;font-weight:bold">
                                                                    Lot Size: {{ lotsize }} Money at Risk :
                                                                    {{ moneyatrisk }}</h3>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        <div v-if="selectedTab === 'retracement'">
                                            <!-- Your margin rate calculator form goes here -->
                                            <!--
                                                                       <h1 >Fibonacci Calculator</h1>-->
                                            <div class="row">

                                                <div
                                                    class="col-md-3 col-sm-12 d-flex justify-content-center align-items-center">
                                                    Market Equity is fully committed to safeguard its clients with AML
                                                    compliance and in respect to all relevant legal requirements. We
                                                    have become one of the efficient companies on Meta’s trader
                                                </div>
                                                <div class="col-md-6 col-sm-12" style="margin-top:2%">
                                                    <div style="width: 100%;
    padding: 20px;
    border-radius: 6px ;
        border: 0px solid #808080; /* Grey border color */

    background: #fff;
    box-shadow: 0 0 6px 0 #808080;">
                                                        <div id="app">
                                                            <div class="form-group">
                                                                <label for="moveType"
                                                                       style="color: #1c879f;text-align: left!important;display: block;">Select
                                                                    Move Type:</label>
                                                                <select v-model="selectedMoveType" class="form-control"
                                                                        style="height:5%">
                                                                    <option value="up">Up Move</option>
                                                                    <option value="down">Down Move</option>
                                                                </select>
                                                            </div>

                                                            <!-- Up Move Division -->
                                                            <div v-if="selectedMoveType === 'up'" class="row"
                                                                 style="padding: 20px; border-radius: 15px; box-shadow: 0 0 0px rgba(0, 0, 0, 0.1); display: flex; border: 0px solid gray;">
                                                                <div class="col-md-12" style="margin-top:0%">
                                                                    <h5 style="color:#1c879f;">Up Move Fib
                                                                        Replacement</h5>
                                                                    <form id="tradingForm4"
                                                                          style="margin-top: 0%; background-color: #ffffff;box-shadow: 0 0 0px 0 #ffffff;">
                                                                        <div class="form-group" style="margin-top:0%">
                                                                            <label for="highvalueupmove"
                                                                                   style="color: #1c879f;text-align: left!important;display: block;">High
                                                                                Value</label>
                                                                            <input id="highvalueupmove"
                                                                                   v-model="highvalueupmove"
                                                                                   class="form-control"
                                                                                   placeholder="Enter High Value"
                                                                                   type="text"/>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <label for="lowvalueupmove"
                                                                                   style="color: #1c879f;text-align: left!important;display: block;">Low
                                                                                Value</label>
                                                                            <input id="lowvalueupmove"
                                                                                   v-model="lowvalueupmove"
                                                                                   class="form-control"
                                                                                   placeholder="Enter Low Value"
                                                                                   type="text"/>
                                                                        </div>
                                                                        <div class="text-center">

                                                                            <button class="btn btn-primary w-100"
                                                                                    style="border-radius: 0px!important;"
                                                                                    type="button"
                                                                                    @click="retracementup">Calculate
                                                                            </button>
                                                                        </div>
                                                                    </form>
                                                                </div>
                                                            </div>


                                                            <!-- Down Move Division -->
                                                            <div v-if="selectedMoveType === 'down'" class="row"
                                                                 style="margin-top:2%; padding: 10px; border-radius: 15px; box-shadow: 0 0 0px rgba(0, 0, 0, 0.1); display: flex; border: 0px solid gray;">
                                                                <div class="col-md-12" style="margin-top:0%">
                                                                    <h5 style="color:#1a859d;">Down Move Fib
                                                                        Replacement</h5>
                                                                    <form id="tradingFormdown"
                                                                          style="margin-top: 0%; background-color: #ffffff;box-shadow: 0 0 0px 0 #ffffff;">
                                                                        <div class="form-group" style="margin-top:0%">
                                                                            <label for="highvaluedownmove"
                                                                                   style="color: #1c879f;text-align: left!important;display: block;">High
                                                                                Value</label>
                                                                            <input id="highvaluedownmove"
                                                                                   v-model="highvaluedownmove"
                                                                                   class="form-control"
                                                                                   placeholder="Enter High Value"
                                                                                   type="text"/>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <label for="lowvaluedownmove"
                                                                                   style="color: #1c879f;text-align: left!important;display: block;">Low
                                                                                Value</label>
                                                                            <input id="lowvaluedownmove"
                                                                                   v-model="lowvaluedownmove"
                                                                                   class="form-control"
                                                                                   placeholder="Enter Low Value"
                                                                                   type="text"/>
                                                                        </div>
                                                                        <div class="text-center">
                                                                            <button class="btn btn-primary w-100"
                                                                                    style="border-radius: 0px!important;"
                                                                                    type="button"
                                                                                    @click="retracementdown">Calculate
                                                                            </button>
                                                                        </div>
                                                                    </form>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div class="col-md-3 col-sm-12">
                                                    <div class="col-md-6" v-if="selectedMoveType === 'up'"
                                                         style="margin-top:2%; padding: 10px; border-radius: 6px;
           box-shadow: 6px 6px 6px 6px rgba(0, 0, 0, 0.1);
           display: flex; border: 0px solid gray;">                                                        <!--                                            <h5 style="color:#1F8AA2!important;">Fib Results UpMove </h5>-->
                                                        <table id="resultTableupmove" class="table">
                                                            <thead style>
                                                            <tr>
                                                                <th>Level</th>
                                                                <th>Price</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr>
                                                                <td>0%</td>
                                                                <td>{{ zeroup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>23.6%</td>
                                                                <td>{{ oneup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>38.2%</td>
                                                                <td>{{ twoup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>50%</td>
                                                                <td>{{ threeup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>61.8%</td>
                                                                <td>{{ fourup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>76.4%</td>
                                                                <td>{{ fiveup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>100%</td>
                                                                <td>{{ sixup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>161.8%</td>
                                                                <td>{{ sevenup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>261.8%</td>
                                                                <td>{{ eightup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>361.8%</td>
                                                                <td>{{ nineup }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>423.6%</td>
                                                                <td>{{ tenup }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div class="col-md-6" v-if="selectedMoveType === 'down'"  style="margin-top:2%; padding: 10px; border-radius: 6px;
           box-shadow: 6px 6px 6px 6px rgba(0, 0, 0, 0.1);
           display: flex; border: 0px solid gray;">
                                                        <!--                                                <h4 style="color:#1F8AA2!important;">Fib Results DownMove</h4>-->
                                                        <table id="resultTabledownmove" class="table">
                                                            <thead>
                                                            <tr>
                                                                <th>Level</th>
                                                                <th>Price</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr>
                                                                <td>0%</td>
                                                                <td>{{ zerodown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>23.6%</td>
                                                                <td>{{ onedown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>38.2%</td>
                                                                <td> {{ twodown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>50%</td>
                                                                <td>{{ threedown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>61.8%</td>
                                                                <td>{{ fourdown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>76.4%</td>
                                                                <td>{{ fivedown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>100%</td>
                                                                <td>{{ sixdown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>161.8%</td>
                                                                <td>{{ sevendown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>261.8%</td>
                                                                <td>{{ eightdown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>361.8%</td>
                                                                <td>{{ ninedown }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>423.6%</td>
                                                                <td>{{ tendown }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                        <div v-if="selectedTab === 'pivotpoints'">
                                            <!-- Your margin rate calculator form goes here -->
                                            <div class="row">
                                                <div
                                                    class="col-md-3 col-sm-12 d-flex justify-content-center align-items-center">
                                                    Market Equity is fully committed to safeguard its clients with AML
                                                    compliance and in respect to all relevant legal requirements. We
                                                    have become one of the efficient companies on Meta’s trader
                                                </div>
                                                <div class="col-md-6 col-sm-12" style="  margin-top:2%">
                                                    <div style="width: 100%;
    padding: 20px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 0 6px 0 #808080;">
                                                        <form
                                                            style="margin-top: 3%; background-color: #ffffff;box-shadow: 0 0 0px 0 #ffffff;">
                                                            <!-- First Row: 2 columns with 2 input fields on the left and 1 on the right -->
                                                            <div class="col-md-12" style="margin-top:0%">
                                                                <!-- Left Column -->
                                                                <div class="form-group">
                                                                    <label for="timeinterval"
                                                                           style="color: #1c879f;text-align: left!important;display: block;">Time
                                                                        Interval</label>
                                                                    <select
                                                                        id="timeintervals"
                                                                        v-model="timeintervalpivot"
                                                                        class="form-control"
                                                                        style="height:2%;width:100%;"
                                                                        @change=priceautofill

                                                                    >
                                                                        <option value="1">1D</option>
                                                                        <option value="2">4HRS</option>

                                                                        <option value="3">1W</option>
                                                                        <!-- Add more options as needed -->
                                                                    </select>
                                                                </div>
                                                                <div class="form-group">
                                                                    <label for="instrument"
                                                                           style="color: #1c879f;text-align: left!important;display: block;">Instrument</label>
                                                                    <select style="width:100%;height:2%;"
                                                                            id="instrumentpivot"
                                                                            v-model="selectedSymbolpivots"
                                                                            class="form-control"
                                                                            @change=priceautofill
                                                                    >
                                                                        <option v-for="item in filteredSymbols" :key="item" :value="item">
                                                                            {{ item }}
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <!-- Right Column -->
                                                            <!--                                                    <div class="form-column">-->
                                                            <!--                                                        <div class="form-group">-->

                                                            <!--                                                            <button-->
                                                            <!--                                                                style="width:250px;color: #1a859d;background-color:#ffffff; "-->
                                                            <!--                                                                class="btn btn-primary" type="button"-->
                                                            <!--                                                                @click="priceautofill">-->
                                                            <!--                                                                Price Auto Fill-->
                                                            <!--                                                            </button>-->
                                                            <!--                                                        </div>-->

                                                            <!--&lt;!&ndash;                                                        <div class="form-group">&ndash;&gt;-->

                                                            <!--&lt;!&ndash;                                                            <button&ndash;&gt;-->
                                                            <!--&lt;!&ndash;                                                                style="width:250px;color: #1a859d;background-color:#ffffff; "&ndash;&gt;-->
                                                            <!--&lt;!&ndash;                                                                class="btn btn-primary" type="button"&ndash;&gt;-->
                                                            <!--&lt;!&ndash;                                                                @click="pivotcalculate">&ndash;&gt;-->
                                                            <!--&lt;!&ndash;                                                                Calculate&ndash;&gt;-->
                                                            <!--&lt;!&ndash;                                                            </button>&ndash;&gt;-->
                                                            <!--&lt;!&ndash;                                                        </div>&ndash;&gt;-->
                                                            <!--                                                    </div>-->


                                                            <!-- Second Row: 4 full-width text input fields below -->
                                                            <div class="form-row">
                                                                <div class="form-group">
                                                                    <label for="field4"
                                                                           style="color: #1c879f;text-align: left!important;display: block;">Open
                                                                        Price</label>
                                                                    <input id="field4" name="field4" type="number"
                                                                           class="form-control"
                                                                           v-model="openprice">
                                                                </div>
                                                                <div class="form-group">
                                                                    <label for="field5"
                                                                           style="color: #1c879f;text-align: left!important;display: block;">High
                                                                        Price</label>
                                                                    <input id="field5" name="field5" type="number"
                                                                           class="form-control"
                                                                           v-model="highprice">
                                                                </div>
                                                                <div class="form-group">
                                                                    <label for="field6"
                                                                           style="color: #1c879f;text-align: left!important;display: block;">Low
                                                                        Price</label>
                                                                    <input id="field6" name="field6" type="number"
                                                                           class="form-control"
                                                                           v-model="lowprice">
                                                                </div>
                                                                <div class="form-group">
                                                                    <label for="field7"
                                                                           style="color: #1c879f;text-align: left!important;display: block;">Close
                                                                        Price</label>
                                                                    <input id="field7" name="field7" type="number"
                                                                           class="form-control"
                                                                           v-model="closeprice">
                                                                </div>
                                                            </div>
                                                        </form>


                                                        <!--                                        <div class="text-center">-->
                                                        <!--                                            <button class="btn btn-primary" type="button" @click="pivotpointscalculate">-->
                                                        <!--                                                Calculate-->
                                                        <!--                                            </button>-->
                                                        <!--                                        </div>-->


                                                    </div>

                                                </div>
                                                <div class="col-md-3 col-sm-12">
                                                    <div class="text-center">
                                                        <div class="col-md-6"  style="margin-top:2%; padding: 10px; border-radius: 6px;
           box-shadow: 6px 6px 6px 6px rgba(0, 0, 0, 0.1);
           display: flex; border: 0px solid gray;">

                                                            <!--                                                    <h5 style="color:#1F8AA2!important;">Pivot Point Results</h5>-->

                                                            <table id="pivots" class="table">
                                                                <thead>
                                                                <tr>
                                                                    <th>Levels</th>
                                                                    <th>Price</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr>
                                                                    <td style="color:red;font-weight:bold">R3</td>
                                                                    <td>{{ r3values }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style="color:red;font-weight:bold">R2</td>
                                                                    <td>{{ r2values }}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style="color:red;font-weight:bold">R1</td>
                                                                    <td style="color:red;font-weight:bold"> {{
                                                                            r1values
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Pivot</td>
                                                                    <td style="font-weight:bold">{{ pivotvalues }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style="color:green;font-weight:bold">S1</td>
                                                                    <td>{{ s1values }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style="color:green;font-weight:bold">S2</td>
                                                                    <td>{{ s2values }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style="color:green;font-weight:bold">S3</td>

                                                                    <td>{{ s3values }}</td>
                                                                </tr>
                                                                <!-- Results will be appended here -->
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>




            <Footer/>
        </div>

    </div>

</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'page',
    data() {
        return {

            selectedTab: 'pip', // Default tab
            selectedMoveType: 'up', // Default to 'up' move
            loading:false,
            symbolsdata: '',
            symbolselected: null,
            pagenameroute: '',
            calculatedvalue: null,
            pagedata: '',
            selectedSymbol: null,
            exchangeRate: 0,
            pipSize: 0,
            positionSize: 1,
            digits: 0,
            currency: "USD",
            minvolume: 1,
            pipvalue: 0,
            step: 0,
            referencepair: null,
            refexchangeRate: 0,
            referencepairlbl2: "Price",
            leverage: '100:1',
            requiredmargin: 0,
            leveragenew: 0,
            lotpipSize: 0,
            accountsize: 0,
            riskvalue: 0,
            risktype: '%',
            stoplossvalue: 0,
            stoplosstype: 'PIPS',
            highvalueupmove: '',
            highvaluedownmove: '',
            lowvalueupmove: '',
            lowvaluedownmove: '',
            zeroup: '',
            zerodown: '',
            oneup: '',
            onedown: '',
            twoup: '',
            twodown: '',
            threeup: '',
            threedown: '',
            fourup: '',
            fourdown: '',
            fiveup: '',
            fivedown: '',
            sixup: '',
            sixdown: '',
            sevenup: '',
            sevendown: '',
            eightup: '',
            eightdown: '',
            nineup: '',
            ninedown: '',
            tenup: '',
            tendown: '',
            selectedSymbolpivots: '',
            openprice: 0,
            closeprice: '',
            lowprice: '',
            highprice: '',
            historydata: '',
            r3values: '',
            r2values: '',
            r1values: '',
            pivotvalues: '',
            s1values: '',
            s2values: '',
            s3values: '',
            lotsize: 0,
            moneyatrisk: 0,
            pipamount: 0,
            timeintervalpivot: 1,
            contractsize: 0,
            profitcurrency: 'USD',
            path:'',
            errors: {},
            marginbuy:1,
            marginsell:1,
            calcmode:0,
            margininitialbuy:0,
            margininitialsell:0,
            marginrate:0,
            tradetype:0,
            margincurrency:'USD',
            loadingmargin:false
        }
    },

    components: {
        Header,
        Footer
    },
    mounted() {

        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js')
        document.head.appendChild(recaptchaScript)
    },
    computed: {
        filteredSymbols() {
            if (Array.isArray(this.symbolsdata)) {
                return this.symbolsdata.filter(item => item !== 'USINDX');
            } else {
                console.error('symbolsdata is not an array:', this.symbolsdata);
                return []; // Return an empty array to avoid breaking the component
            }
        }

    },
    beforeMount() {


        var pathvalues = (this.$route.path).split("/");


        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
        }
        this.langchange = this.$i18n.locale;
        this.pagenameroute = pathvalues[3];
        this.loadpagedata(pathvalues[2]);

        this.loadsymboldata();

    },

    methods: {
        isFieldInvalid(fieldName) {
            return !!this.errors[fieldName];
        },

        formatNumber(value, locale = 'en-US', options = {}) {
            return new Intl.NumberFormat(locale, options).format(value);
        },
        retracementdown(event) {

            event.stopPropagation(); // Stop event from bubbling up

            this.zerodown = (Number(this.lowvaluedownmove) + ((Number(this.highvaluedownmove) - Number(this.lowvaluedownmove))) * 0).toFixed(2).toString();
            this.onedown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 0.236)).toFixed(2).toString();
            this.twodown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 0.382)).toFixed(2).toString();
            this.threedown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 0.5)).toFixed(2).toString();

            this.fourdown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 0.618)).toFixed(2).toString();
            this.fivedown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 0.764)).toFixed(2).toString();
            this.sixdown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 1)).toFixed(2).toString();

            this.sevendown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 1.618)).toFixed(2).toString();
            this.eightdown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 2.618)).toFixed(2).toString();

            this.ninedown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 3.618)).toFixed(2).toString();
            this.tendown = (parseFloat(this.lowvaluedownmove) + parseFloat((this.highvaluedownmove - this.lowvaluedownmove) * 4.236)).toFixed(2).toString();


        },


        retracementup(event) {
            event.stopPropagation(); // Stop event from bubbling up

            this.zeroup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove)) * 0).toFixed(2).toString();

            this.oneup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 0.236)).toFixed(2).toString();
            this.twoup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 0.382)).toFixed(2).toString();
            this.threeup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 0.5)).toFixed(2).toString();

            this.fourup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 0.618)).toFixed(2).toString();
            this.fiveup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 0.764)).toFixed(2).toString();
            this.sixup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 1)).toFixed(2).toString();

            this.sevenup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 1.618)).toFixed(2).toString();
            this.eightup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 2.618)).toFixed(2).toString();

            this.nineup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 3.618)).toFixed(2).toString();
            this.tenup = (this.highvalueupmove - ((this.highvalueupmove - this.lowvalueupmove) * 4.236)).toFixed(2).toString();


        },
        loadpagedata(pagename) {

            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.pagedata = res.data.pagedata[0];


                    }
                });


        },

        updatePipSize(digits) {
            if (digits >= 1) {
                this.pipSize = 1 / Math.pow(10, digits - 1);
            } else {
                this.pipSize = 1; // Default or fallback value for invalid digit input
            }
        },

        lotcalculate() {


              //  alert(this.pipvalue);
                this.loading = true; // Start loading and show "Calculating..."


                    if (this.risktype == "%") {
                this.moneyatrisk = (this.positionSize * this.riskvalue) / 100;

            }
            if (this.risktype == "USD") {
                this.moneyatrisk = (this.positionSize * this.riskvalue);

            }


            setTimeout(() => {
                this.pipcalculate();
                if (this.stoplosstype == 'PIPS') {
                    this.pipamount = this.stoplossvalue * this.pipvalue;
                }
                else{
                    this.pipamount = this.stoplossvalue - this.exchangeRate;

                }
                // alert(this.pipamount)
                this.lotsize = (((this.riskvalue / this.pipamount))*this.positionSize).toFixed(3);
                // Delay in milliseconds (2 seconds here)
                this.loading = false; // Start loading and show "Calculating..."



            }, 2000); // Delay in milliseconds (2 seconds here)

        },
        loadsymboldata() {
            this.$axios.get("getSymbols")
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.symbolsdata = res.data.answer;

                        const firstValues = this.symbolsdata.map(obj => {
                            // Get the first key of the object

                            const firstKey = Object.keys(obj)[0];
                            // Return the value associated with the first key

                            return obj[firstKey];
                        });
                        this.symbolsdata = firstValues;
                        this.symbolsdata.slice().sort((a, b) => a.localeCompare(b));

                    }
                });


        },
        // oninstrumentSymbolChange(){
        //
        // },
        onSymbolChangemargin(event) {
            const symbol = event.target.value;
            this.referencepair = null;
            this.pipvalue = 0;
            this.exchangeRate = 0;
            this.positionSize = 1;
            this.selectedSymbol = symbol;
            //alert(this.selectedSymbol);
            this.$axios.get(`getsymbolinfo/${this.selectedSymbol}`)
                .then(response => {
                    console.log(response.data);


                    if (response.data.answer) {
                        // alert("yes2")

                        this.digits = response.data.answer.Digits;
                        this.contractsize = response.data.answer.ContractSize;
                        //this.currency = response.data.answer.CurrencyBase;
                        this.step = (response.data.answer.VolumeMin) / 10000;
                        this.marginbuy = response.data.answer.MarginInitialBuy;
                        this.marginsell = response.data.answer.MarginInitialSell;
                        this.calcmode = response.data.answer.CalcMode;
                        this.margininitialbuy = response.data.answer.MarginInitialBuy;
                        this.margininitialsell = response.data.answer.MarginInitialSell;
                        this.margincurrency=response.data.answer.CurrencyMargin;
                        // this.digits=response.data.answer.Digits;

                    }




                });



        },




        onSymbolChange(event) {
            const symbol = event.target.value;
            this.referencepair = null;
            this.pipvalue = 0;
            this.exchangeRate = 0;
            this.positionSize = 1;
            this.selectedSymbol = symbol;
            //alert(this.selectedSymbol);
            this.$axios.get(`getsymbolinfo/${this.selectedSymbol}`)
                .then(response => {
                    console.log(response.data);


                    if (response.data.answer) {
                        // alert("yes2")

                        this.digits = response.data.answer.Digits;
                        this.contractsize = response.data.answer.ContractSize;
                        //this.currency = response.data.answer.CurrencyBase;
                        this.step = (response.data.answer.VolumeMin) / 10000;
                        this.profitcurrency = response.data.answer.CurrencyProfit;
                        this.path=response.data.answer.Path;
                        this.path=response.data.answer.Path;
                        // this.digits=response.data.answer.Digits;

                        // alert(this.path);
                        this.updatePipSize(this.digits);
                    }




                });

          //  this.getSymbolInfo(symbol)
            //   alert(symbol);


           //return false;
           //  if (!this.isSixCharacters()) {

                if ((!symbol.includes("USD"))) {

                    this.$axios.get(`getsymbolinfo/${symbol}`)
                        .then(response => {
                            console.log(response.data);
                            this.profitcurrency = response.data.answer.CurrencyProfit;
                            if (this.profitcurrency == this.currency) {


                                if (response.data.answer) {
                                    this.digits = response.data.answer.Digits;
                                    this.contractsize = response.data.answer.ContractSize;
                                    //this.currency = response.data.answer.CurrencyBase;
                                    this.step = (response.data.answer.VolumeMin) / 10000;
                                    this.profitcurrency = response.data.answer.CurrencyProfit;
                                    this.updatePipSize(this.digits);

                                }
                            }
                            if (this.profitcurrency != this.currency) {

                                this.referencepair = this.profitcurrency + this.currency;
                                this.$axios.get(`getsymbolprice/${this.referencepair}`)
                                    .then(response => {
                                        console.log(response.data);

                                        if (response.data.trans_id == 0) {
                                          //  this.refexchangeRate = response.data.answer[0].Bid;
                                            this.referencepair = this.currency + this.profitcurrency;
                                            this.$axios.get(`getsymbolprice/${this.referencepair}`)
                                                .then(response => {
                                                    console.log(response.data);
                                                    if (response.data.answer)
                                                        this.refexchangeRate = response.data.answer[0].Bid;

                                                });
                                            // if (this.refexchangeRate == 0) {
                                            //     this.referencepair = this.profitcurrency + this.currency;
                                            //     this.$axios.get(`getsymbolprice/${this.referencepair}`)
                                            //         .then(response => {
                                            //             console.log(response.data);
                                            //             if (response.data.answer)
                                            //                 this.refexchangeRate = response.data.answer[0].Bid;
                                            //
                                            //         });
                                            // }
                                        }

                                    else {
                                           // this.referencepair = this.currency + this.profitcurrency;
                                            this.$axios.get(`getsymbolprice/${this.referencepair}`)
                                                .then(response => {
                                                    console.log(response.data);
                                                    if (response.data.answer)
                                                        this.refexchangeRate = response.data.answer[0].Bid;

                                                });
                                            // if (this.refexchangeRate == 0) {
                                            //     this.referencepair = this.profitcurrency + this.currency;
                                            //     this.$axios.get(`getsymbolprice/${this.referencepair}`)
                                            //         .then(response => {
                                            //             console.log(response.data);
                                            //             if (response.data.answer)
                                            //                 this.refexchangeRate = response.data.answer[0].Bid;
                                            //
                                            //         });
                                            // }
                                        }
                                    });
                                return false;

                            }
                      else{
                                this.getSymbolprice(symbol);

                            }

                        });


                }
          //  }

//             if (this.isSixCharacters()) {
//                 if ((!this.selectedSymbol.includes("USD"))) {
// alert("dfdsf")
//                     this.referencepair = this.selectedSymbol.slice(-3) + this.currency;
//                     // alert(this.referencepair);
//                     if (this.referencepair) {
//                         //this.getSymbolInfo(this.referencepair);f
//                         this.gerefSymbolprice(this.referencepair);
//
//                     }
//
//
//                 }
//             }


            if (symbol) {
                this.getSymbolInfo(symbol);
                this.getSymbolprice(symbol);
                this.refexchangeRate = this.exchangeRate;
            }
        },

        pivotcalculate() {
            this.pivotvalues = ((this.highprice + this.lowprice + this.closeprice) / 3).toFixed(5);
            this.r1values = ((2 * this.pivotvalues) - this.lowprice).toFixed(5);
            this.r2values = (parseFloat(this.pivotvalues) + parseFloat(this.highprice) - parseFloat(this.lowprice)).toFixed(5);
            this.s2values = (parseFloat(this.pivotvalues) - parseFloat(this.highprice) + parseFloat(this.lowprice)).toFixed(5);
            this.s3values = (parseFloat(this.lowprice) - 2 * (parseFloat(this.highprice) - parseFloat(this.closeprice))).toFixed(5);
            this.r3values = (parseFloat(this.highprice) + 2 * (parseFloat(this.pivotvalues) - parseFloat(this.lowprice))).toFixed(5);
            this.s1values = (2 * (parseFloat(this.pivotvalues)) - parseFloat(this.lowprice)).toFixed(5);

        },
        priceautofill(event) {
            event.stopPropagation(); // Stop event from bubbling up
            const symbolpivot = this.selectedSymbolpivots;
            if(symbolpivot) {
                this.$axios.get(`gettickhistory/${symbolpivot}/${this.timeintervalpivot}`)
                    .then(response => {
                        console.log(response.data);


                        console.log(response.data.answer[response.data.answer.length - 1]);
                        this.historydata = response.data.answer[response.data.answer.length - 1];
                        this.openprice = this.historydata[1];
                        this.highprice = this.historydata[2];
                        this.lowprice = this.historydata[3];
                        this.closeprice = this.historydata[4];
                        this.pivotcalculate()

                    });
            }
        },
        onSymbolChangerequiredmargin(event) {
            const symbol = event.target.value;
            this.referencepairlbl2 = null;
            this.exchangeRate = 0;
            this.positionSize = 1;
            this.selectedSymbol = symbol;
            if (symbol) {
                this.getSymbolInfo(symbol);
                this.getSymbolprice(symbol);

            }
            if (this.isSixCharacters()) {

                if ((!this.selectedSymbol.startsWith("USD") && !this.selectedSymbol.endsWith("USD"))) {
                    this.referencepairlbl2 = this.selectedSymbol.slice(0, 3) + this.currency;

                    if (this.referencepairlbl2) {
                        //this.getSymbolInfo(this.referencepair);
                        this.gerefSymbolprice(this.referencepairlbl2);

                    }
                    // alert(this.referencepair);
                } else {
                    this.referencepairlbl2 = symbol;
                    this.gerefSymbolprice(symbol);
                    // alert(this.referencepair);
                }
            } else {
                this.referencepairlbl2 = symbol;
                this.gerefSymbolprice(symbol);

            }


        },

        pipcalculate() {
            // alert("this is ref pair"+this.referencepair);
            this.errors = {}; // Reset errors

            if (!this.selectedSymbol) {
                this.errors.selectedSymbol = 'Instrument is required';
            }
            if (!this.positionSize || this.positionSize <= 0) {
                this.errors.positionSize = 'Position size must be greater than 0';
            }
            if (!this.currency) {
                this.errors.currency = 'Currency is required';
            }

            // You can add more validation rules here...

            // If no errors, proceed with the calculation
            if (Object.keys(this.errors).length === 0) {
                this.loading = true; // Start loading and show "Calculating..."
                if (this.path.includes("US CFD")) {
                    // alert("hii");
                    this.loading = false;
                    this.pipvalue = (this.positionSize * 0.01).toFixed(this.digits);
                    this.pipSize = 0.1;
                    this.loading = false; // Start loading and show "Calculating..."

                    return this.pipvalue;
                }
                // if (this.path.includes("US Indices")) {
                //     // alert("hii");
                //     this.loading = false;
                //     this.pipvalue = (this.positionSize * this.contractsize*this.pipSize).toFixed(this.digits);
                //     // this.pipSize = 0.1;
                //     // alert( this.pipSize)
                //     this.loading = false; // Start loading and show "Calculating..."
                //
                //     return this.pipvalue;
                // }
                setTimeout(() => {
                    // alert(this.selectedSymbol);
                    if (this.selectedSymbol.startsWith("USD")) {
                        this.pipvalue = ((this.positionSize*100000 * (this.pipSize / this.exchangeRate)) ).toFixed(this.digits);
                        this.loading = false; // Start loading and show "Calculating..."

                        return this.pipvalue;

                    }
                    else if (this.selectedSymbol == "AUDUSD" || this.selectedSymbol == "NZDUSD" || this.selectedSymbol == "EURUSD" || this.selectedSymbol == "GBPUSD") {
//                 alert(this.selectedSymbol);
//                 alert("eurrusd");
// alert(this.positionSize)
                        this.pipvalue = (this.positionSize * 10).toFixed(this.digits);
                        //  alert(this.pipvalue)
                        this.loading = false; // Start loading and show "Calculating..."

                        return this.pipvalue;


                    }
                    else if (this.selectedSymbol == "XAGUSD") {
                        this.pipvalue = (this.positionSize * 50).toFixed(this.digits);
                        this.loading = false; // Start loading and show "Calculating..."

                        return this.pipvalue;

                    }
                    else if (this.selectedSymbol == "NATGAS_V24") {
                        this.pipvalue = (this.positionSize * 50).toFixed(this.digits);
                        this.loading = false; // Start loading and show "Calculating..."

                        return this.pipvalue;

                    }
                    else if (this.selectedSymbol == "BRENT" || this.selectedSymbol == "US_Oil_U24" || this.selectedSymbol == "WTI") {
                        this.pipvalue = (this.positionSize * 10).toFixed(this.digits);
                        this.pipSize = 0.01;
                        this.loading = false; // Start loading and show "Calculating..."

                        return this.pipvalue;

                    }
                    // else if (this.selectedSymbol.startsWith("XAGUSD")) {
                    //     this.pipvalue = (this.positionSize * 50).toFixed(this.digits);
                    //     this.pipSize = 0.1;
                    //     this.loading = false; // Start loading and show "Calculating..."
                    //
                    //     return this.pipvalue;
                    //
                    // }
                    else if (this.selectedSymbol == "XAUUSD" || this.selectedSymbol == "XPTUSD" || this.selectedSymbol == "XPDUSD") {
                        this.pipvalue = (this.positionSize * 10).toFixed(this.digits);
                        this.pipSize = 0.1;
                        this.loading = false; // Start loading and show "Calculating..."

                        return this.pipvalue;


                    } else if (this.selectedSymbol == "US30" || this.selectedSymbol == "US100" || this.selectedSymbol == "US500") {
                        this.pipvalue = (this.positionSize * this.contractsize*this.pipSize).toFixed(this.digits);
                        this.pipSize = 0.1;
                        this.loading = false; // Start loading and show "Calculating..."

                        return this.pipvalue;

                    }
                    else if (this.referencepair) {


                        if (this.referencepair.startsWith("USD")) {
                            this.pipvalue = (((this.positionSize*this.contractsize * this.pipSize) / this.refexchangeRate) ).toFixed(this.digits);
                            this.loading = false; // Start loading and show "Calculating..."

                            return this.pipvalue;

                        }
                        if (this.referencepair.endsWith("USD")) {

                            this.pipvalue = (((this.positionSize*this.contractsize * this.pipSize) * this.refexchangeRate)).toFixed(this.digits);
                            this.loading = false; // Start loading and show "Calculating..."

                            return this.pipvalue;

                        }
                    }
                     else {
                    //
                        this.pipvalue = ((this.positionSize*100000 * (this.pipSize / this.exchangeRate)) ).toFixed(this.digits);
                         this.loading = false; // Start loading and show "Calculating..."

                        return this.pipvalue;

                    }
                    this.loading = false; // Start loading and show "Calculating..."

                }, 2000); // Delay in milliseconds (2 seconds here)
                return this.pipvalue;
            }

        },

        margincalculate() {
            // alert(this.calcmode);
            this.refexchangeRate =0;

            this.requiredmargin=0;
            const liverageparts = this.leverage.split(":");
            this.leveragenew = parseFloat(liverageparts[0]);
            if (this.tradetype == 0) {
                this.marginrate = this.margininitialbuy;
            }
            if (this.tradetype == 1) {
                this.marginrate = this.margininitialsell;
            }

            if (this.margincurrency != "USD") {


                this.referencepair = this.currency + this.margincurrency;
                // alert(this.referencepair);
                this.$axios.get(`getsymbolprice/${ this.referencepair}`)
                    .then(response => {
                        console.log(response.data);


                        this.refexchangeRate = response.data.answer[0].Bid;
                        // alert(this.exchangeRate);
                        // alert(this.refexchangeRate);

                    });
                if( this.refexchangeRate==0){
                    this.referencepair = this.margincurrency+this.currency;
                    this.$axios.get(`getsymbolprice/${ this.referencepair}`)
                        .then(response => {
                            console.log(response.data);


                            this.refexchangeRate = response.data.answer[0].Bid;
                            // alert(this.exchangeRate);
                            // alert(this.refexchangeRate);
                        });
                }
             }
           else {
              // alert("hiii")
               // alert(this.calcmode);
                this.$axios.get(`getsymbolprice/${ this.symbolselected}`)
                    .then(response => {
                        console.log(response.data);


                        this.exchangeRate = response.data.answer[0].Bid;

                    });


            }


            setTimeout(() => {
                this.loadingmargin = true; // Start loading and show "Calculating..."
                this.requiredmargin=0;


                if(this.calcmode==0) {
                    this.loadingmargin = true;
                    if (this.margincurrency == "USD") {

                        this.requiredmargin = ((((this.positionSize * this.contractsize * this.marginrate / this.leveragenew)))).toFixed(5);
                        this.loadingmargin = false;


                        return this.requiredmargin;
                    } else {

                        if (this.symbolselected.slice(0, 3) === this.margincurrency) {
                            this.requiredmargin = ((((this.positionSize * this.contractsize * this.refexchangeRate) / this.leveragenew))).toFixed(5);
                            this.loadingmargin = false;
                            return this.requiredmargin;

                        }
                        // if (this.symbolselected.slice(-3)  === this.margincurrency) {
                        //     this.requiredmargin = ((((this.positionSize * this.contractsize * this.refexchangeRate) / this.leveragenew))).toFixed(5);
                        //     this.loadingmargin = false;
                        //     return this.requiredmargin;
                        //
                        // }

                        if (this.refexchangeRate) {
                            this.requiredmargin = ((((this.positionSize * this.contractsize * this.marginrate / this.leveragenew)))).toFixed(5);
                            this.loadingmargin = false;


                            return this.requiredmargin;
                        }


                    }
                }
                if(this.calcmode==4){
                   // alert("yes")
                    if(this.margincurrency=="USD") {
                        this.requiredmargin = ((this.positionSize  * this.contractsize * this.marginrate * this.exchangeRate) / this.leveragenew).toFixed(5);
                        this.loadingmargin = false;

                        return this.requiredmargin;
                    }

                else {
                        //alert("noo")


                        if (this.refexchangeRate) {
                            this.requiredmargin = ((this.positionSize * this.contractsize * this.marginrate * this.refexchangeRate / this.leveragenew)).toFixed(5);
                            this.loadingmargin = false;

                            return this.requiredmargin;
                        }

                    }
                }
                if(this.calcmode==1){
                   // alert("yes")
                    if(this.margincurrency=="USD") {
                        this.requiredmargin = ((this.positionSize  * this.contractsize * this.marginrate * this.exchangeRate) / this.leveragenew).toFixed(5);
                        this.loadingmargin = false;

                        return this.requiredmargin;

                    }

                    else {
                       // alert("noo")


                        if (this.refexchangeRate) {
                            this.requiredmargin = ((this.positionSize * this.contractsize * this.marginrate * this.refexchangeRate / this.leveragenew)).toFixed(5);
                            this.loadingmargin = false;

                            return this.requiredmargin;
                        }

                    }
                }
                this.loadingmargin = false; // Start loading and show "Calculating..."

            }, 2000); // Delay in milliseconds (2 seconds here)
            this.loadingmargin = false; // Start loading and show "Calculating..."

        },
        isSixCharacters() {
            //  alert("Checking symbol");
            return /^[A-Za-z0-9]{6}$/.test(this.selectedSymbol);
        },
        convertCurrencyPair(pair) {
            const parts = pair.split(" "); // Split the string into an array

            // Filter out "USD" from the array
            const filteredParts = parts.filter(part => part !== "USD");

            return "USD" + filteredParts.join(""); // Concatenate "USD" at the start and join the remaining parts
        },


        getSymbolInfo(symbol) {
            this.$axios.get(`getsymbolinfo/${symbol}`)
                .then(response => {
                    console.log(response.data);
                    // alert(response.data.retcode)
                    if (response.data.retcode == "13 Not found") {
                        if (symbol.startsWith("USD")) {
// alert("yes");
                            symbol = symbol(0, 3) + "USD";
                        } else {
                            // alert("no");

                            symbol = "USD" + symbol.substring(0, 3);
                            this.referencepair = symbol;
                            this.gerefSymbolprice(symbol);
                        }


                    }

                    if (response.data.answer) {
                        // alert("yes2")

                        this.digits = response.data.answer.Digits;
                        this.contractsize = response.data.answer.ContractSize;
                        //this.currency = response.data.answer.CurrencyBase;
                        this.step = (response.data.answer.VolumeMin) / 10000;
                        this.profitcurrency = response.data.answer.CurrencyProfit;
                        this.marginbuy = response.data.answer.MarginInitialBuy;
                        this.marginsell = response.data.answer.MarginInitialSell;
                        this.calcmode = response.data.answer.CalcMode;
                        this.margininitialbuy = response.data.answer.MarginInitialBuy;
                        this.margininitialsell = response.data.answer.MarginInitialSell;
                        this.margincurrency=response.data.answer.CurrencyMargin;



                        this.path=response.data.answer.Path;
                        // alert(this.path);
                        this.updatePipSize(this.digits);
                    }

                });
        }
        ,
        getSymbolprice(symbol) {
            this.$axios.get(`getsymbolprice/${symbol}`)
                .then(response => {
                    console.log(response.data);


                    this.exchangeRate = response.data.answer[0].Bid;

                });
        }
        ,

        gerefSymbolprice(referencepairsymbol) {
            // alert(referencepairsymbol);

            this.$axios.get(`getsymbolprice/${referencepairsymbol}`)
                .then(response => {
                    console.log(response.data);
                    //alert(response.data.trans_id);
                    if (response.data.trans_id == 0) {
                        if (this.referencepairsymbol == this.currency + this.selectedSymbol.slice(-3))
                            this.referencepair = this.selectedSymbol.slice(0, 3) + this.currency;
                        else {
                            this.referencepair = this.selectedSymbol.slice(-3) + this.currency;

                        }


                        // alert(this.referencepair);
                        // this.gerefSymbolprice(this.referencepair) ;
                        this.getSymbolInfo(this.referencepair);


                    } else {
                        this.refexchangeRate = response.data.answer[0].Bid;
                    }


                });
            //alert( this.refexchangeRate);
        }
    }

}
</script>
<style>
.is-invalid {
    border-color: red;
}

.form-content {
    width: 100% !important;
}


table, th, td {
    border: 0px solid black;
    border-collapse: collapse;
}

.output-container {
    display: flex;
    justify-content: center; /* Center the box horizontally */
}

.output-box {
    background-color: #ffffff; /* Light grey background */
    padding: 20px; /* Space inside the box */
    border-radius: 0px; /* Rounded corners */
    box-shadow: 0 0 0px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
    max-width: 300px; /* Maximum width of the box */
    text-align: center; /* Center the text inside the box */
    margin-top: 5%;
    border: 0px solid #1F8AA2; /* Change the color as needed */
    /* Top margin */
}

.form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.form-content {
    width: 50%;
}
</style>
<style>
.nav-tabs .nav-link {
    cursor: pointer;
}

th {
    background-color: #ffffff;
    color: #000000;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

.carousel {
    background: #2f4357;
    margin-top: 20px;
}

.carousel-item {
    text-align: center;
    min-height: 280px; /* Prevent carousel from being distorted if for some reason image doesn't load */
}

.rtlclass {
    direction: rtl !important;


}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}

#tabela th, td {
    padding: 30px;
}

tabela tr:nth-child(even) {
    background-color: #f2f2f2;
}

a:hover, a:focus {
    text-decoration: none;
    outline: none;
}

#accordion .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 15px;
}

#accordion .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordion .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 1px 1px 1px #fff;
    position: relative;

}

#accordion .panel-title a:before {
    content: "-";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: #929191;
    font-size: 12px;
    font-weight: 900;
    color: #fdfbfb;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;
}

#accordion .panel-title a.collapsed:before {
    content: "+";
}

#accordion .panel-body {
    padding: 10px 15px;
    font-size: 15px;
    color: #222;
    line-height: 27px;
    border: none;
}

#accordion .panel-body p {
    margin-bottom: 0;
}

.text-center {
    display: flex !important;
    justify-content: center !important;
}

.container {
    max-width: 800px; /* Adjust as needed */
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    /*background-color: #f9f9f9;*/
}

.form-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
}

.form-group {
    flex: 1;
    margin-right: 10px;
}

.form-group:last-child {
    margin-right: 0;
}

input[type="text"], input[type="email"], input[type="password"] {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.nav-tabs {
    border-bottom: 0px solid #741717 !important;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #495057;
    background-color: #fff;
    border-top-color: rgb(255, 255, 255);
    border-right-color: rgb(255, 255, 255);
    border-bottom-color: #1F8AA2;
    border-left-color: rgb(255, 255, 255);

}
thead {
    text-align: center; /* Centers text horizontally */
}

thead th {
    text-align: center; /* Centers text horizontally */
}
th {
    background-color: #ffffff!important;
    color: #000000!important;
}
</style>

